import React, { useMemo } from "react";
import { Box, Button, Divider, Paper, Typography } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { setPage, setRowsPerPage } from "../../store/slices/paginationSlice";

import { CREATE_UPDATE_BUTTON } from "../../styles/ButtonStyles";
import TenantElectricityTable from "./TenantElectricityTable";
import PaginationManager from "../../components/newComp/Pagination";

const TenantElectricityConsumption = ({
  tenants,
  tenantConsumption,
  handleConsumptionChange,
  handleGenerateInvoice,
}) => {
  const dispatch = useDispatch();
  const { page, rowsPerPage } = useSelector((state) => state.pagination);

  const handleChangePage = (event, newPage) => {
    dispatch(setPage(newPage));
  };

  const handleChangeRowsPerPage = (event) => {
    dispatch(setRowsPerPage(parseInt(event.target.value, 10)));
    dispatch(setPage(0)); // Reset to page 0
  };

  // Slice the current page's data
  const currentPageData = useMemo(() => {
    return tenants.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [tenants, page, rowsPerPage]);

  if (!tenants || tenants.length === 0) return null;

  return (
    <Box
      sx={{
        width: "100%",
        mt: 4,
        px: { xs: 2, sm: 3 },
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: "100%",
          borderRadius: 3,
          p: { xs: 3, sm: 4 },
          backgroundColor: "#fff",
          boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Tenant Electricity Consumption
        </Typography>

        <Divider sx={{ mb: 1 }} />

        {/* Table with paginated data */}
        <TenantElectricityTable
          tenants={currentPageData}
          tenantConsumption={tenantConsumption}
          handleConsumptionChange={handleConsumptionChange}
        />

        <Divider sx={{ mt: 3, mb: 3 }} />

        {/* Pagination below table */}
        <PaginationManager
          count={tenants.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        <Divider />

        <Box sx={{ mt: 3 }}>
          <Button
            variant="contained"
            sx={CREATE_UPDATE_BUTTON}
            onClick={handleGenerateInvoice}
          >
            Generate Invoice
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default TenantElectricityConsumption;
